export default function createErrorMessage(error, defaultError = "error.general") {
    if (error.graphQLErrors) {
        return error.graphQLErrors[0]?.message || defaultError;
    } else if (error.message) {
        return error.message;
    } else {
        return defaultError;
    }
};